<df-form-field [ngClass]="class" [id]="labelId" [label]="label" [required]="required" [helpText]="hint"
  [errors]="showErrors ? errors() : []" [touched]="controlFC.touched" [dirty]="controlFC.dirty">
  <div class="value-with-unit">
    <df-number-input [id]="labelId" [formControl]="controlFC" [readonly]="readonly"
      [min]="minValue" [max]="maxValue" [step]="step ?? 1"
      [suffixText]="unitList.length === 1 ? unitControlFG.valueFC.value : undefined" />
    @if (unitList.length > 1) {
      <df-select class="unit-select" ariaLabel="Unit" [searchable]="false" [clearable]="false"
        [options]="unitOptions" [formControl]="unitKeyFC" />
    }
  </div>
</df-form-field>
